import { render } from "./ExtraImageChooserBar.vue?vue&type=template&id=316de274&scoped=true"
import script from "./ExtraImageChooserBar.vue?vue&type=script&lang=js"
export * from "./ExtraImageChooserBar.vue?vue&type=script&lang=js"

import "./ExtraImageChooserBar.vue?vue&type=style&index=0&id=316de274&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-316de274"

export default script